export const info = msg => {
  if (process.env.NODE_ENV !== 'development') return;
  console.log('%c info: ', 'color: green', msg);
};

export const error = msg => {
  if (process.env.NODE_ENV !== 'development') return;
  console.error('error: ', msg);
};

export const warn = msg => {
  if (process.env.NODE_ENV !== 'development') return;
  console.log('%c warn: ', 'color: red', msg);
};

export const verbose = msg => {
  if (process.env.NODE_ENV !== 'development') return;
  console.log('%c verbose: ', 'color: blue', msg);
};

export const silly = msg => {
  if (process.env.NODE_ENV !== 'development') return;
  console.log('%c silly: ', 'color: pink', msg);
};
